import groq from 'groq';
import { PARENT_FIELD } from '@pkg/config/sanity/constants';

/**
 * Get a slug for a page, based on its own slug and the slugs of its parents.
 */
export const slugWithParents = groq`
  "slug": '/'+slug.current,
  defined(${PARENT_FIELD}) => {"slug": '/'+ ${PARENT_FIELD}->slug.current+'/'+slug.current},
  defined(${PARENT_FIELD}->${PARENT_FIELD}) => {"slug": '/'+${PARENT_FIELD}->${PARENT_FIELD}->slug.current+'/'+${PARENT_FIELD}->slug.current+'/'+slug.current},
  defined(${PARENT_FIELD}->${PARENT_FIELD}->${PARENT_FIELD}) => {"slug": '/'+ ${PARENT_FIELD}->${PARENT_FIELD}->${PARENT_FIELD}->slug.current +'/'+${PARENT_FIELD}->${PARENT_FIELD}->slug.current +'/'+${PARENT_FIELD}->slug.current+'/'+slug.current}
`;

/**
 * For use in the Slug field, in Sanity.
 */
export const parentsSlug = groq`
  "slug": "",
  defined(${PARENT_FIELD}) => {
    "slug": ${PARENT_FIELD}->slug.current + '/'
  },
  defined(${PARENT_FIELD}->${PARENT_FIELD}) => {
    "slug": ${PARENT_FIELD}->${PARENT_FIELD}->slug.current + '/' + ${PARENT_FIELD}->slug.current + '/',
  },
  defined(${PARENT_FIELD}->${PARENT_FIELD}->${PARENT_FIELD}) => {
    "slug": ${PARENT_FIELD}->${PARENT_FIELD}->${PARENT_FIELD}->slug.current + '/' + ${PARENT_FIELD}->${PARENT_FIELD}->slug.current + '/' + ${PARENT_FIELD}->slug.current + '/',
  },
`;
